import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const permissionsQuery = createApi({
  baseQuery,
  reducerPath: "permissionsQueries",
  endpoints: (builder) => ({
    getAllPermissions: builder.mutation<any, any>({
      query: ({
        from = 0,
        size = -1,
        value = "",
        sort_by = "",
        sort_order = "",
        data,
      }) => ({
        url: `${formatString(
          endPoints.permissions.getAllPermissions
        )}?from=${from}&size=${size}${
          value && `&value=${encodeURIComponent(value)}`
        }${sort_by && `&sort_by=${sort_by}`}${
          sort_order && `&sort_order=${sort_order}`
        }`,
        method: "POST",
        body: data,
      }),
    }),
    getAllUIPermissions: builder.query<any, any>({
      query: () => ({
        url: `${formatString(endPoints.permissions.UIPermissions)}`,
        method: "GET",
      }),
    }),
  }),
});

export const { useGetAllPermissionsMutation, useLazyGetAllUIPermissionsQuery } =
  permissionsQuery;
